import { render, staticRenderFns } from "./DataXueHongDanBai.vue?vue&type=template&id=5bac7606&"
import script from "./DataXueHongDanBai.vue?vue&type=script&lang=js&"
export * from "./DataXueHongDanBai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports